import { render, staticRenderFns } from "./FTStatistics.vue?vue&type=template&id=4f6e3abe&scoped=true&"
import script from "./FTStatistics.vue?vue&type=script&lang=js&"
export * from "./FTStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6e3abe",
  null
  
)

export default component.exports